import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of, switchMap } from "rxjs";
import { ExamService } from "src/app/shared/services/settings/exam";
import { appEventActions } from "../../app-event";
import { examActions } from "./exam.action";

@Injectable()
export class ExamEffects {
    constructor(
        private actions$: Actions,
        private examService: ExamService,
    ) {}

    getExams$ = createEffect(() =>
        this.actions$.pipe(
            ofType(examActions.loadExams),
            mergeMap(() =>
                this.examService.getAllExams().pipe(map((data) => examActions.setExams({ data: data?.rows }))),
            ),
        ),
    );

    create$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(examActions.create),
            switchMap((data) =>
                this.examService.create(data.data).pipe(
                    switchMap(() => {
                        data.onClose(true);

                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Exam created successfully.",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    update$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(examActions.update),
            switchMap((data) =>
                this.examService.update(data.data, data.id).pipe(
                    switchMap(() => {
                        data.onClose(true);
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Exam updated successfully.",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });
}
